<!--
Author: TangChen
Date: 2018-09-25
Desc: 重置密码类型登录和交易密码，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-reset-pwd-way bizcomp ' + className">
        <comp-title :title="title" />
        <el-row>
            <el-col v-for="(item,index) in resetWays" :key="index" :span="22" :offset="1">
                <hint-card :data="item" v-on:btn-click="loadPage" />
            </el-col>
        </el-row>
        <div class="return-login">
            <a href="javascript:void(0)" title="返回登录页面" v-on:click.once="returnBtn">&lt;&nbsp;返回登录页面</a>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import hintCard from "@/components/layout/hintCard.vue";
export default {
    name: "ResetPwdWay",
    components: {
        hintCard
    },
    mixins: [mixin],
    data () {
        return {
            resetWays: [
                { icon: "fa fa-mobile", tit: "通过手机号找回登录密码", text: "通过手机快速登录，还未绑定银行卡的用户可找回登录密码", cla: "", btnArr: [{ btn: "找回登录密码", page: "resetlogin" }] },
                { icon: "fa fa-credit-card", tit: "通过银行卡找回交易密码", text: "已绑定银行卡的用户可找回交易密码", cla: "blue", btnArr: [{ btn: "找回交易密码", page: "resetrade" }] }
            ]
        };
    },
    methods: {
        loadPage (page) {
            this.$router.push({ name: page });
        },
        /* 跳转到登录 */
        returnBtn () {
            this.$router.push("/");
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-reset-pwd-way {
    .fa-mobile {
        font-size: 50px;
    }
    .return-login {
        text-align: center;
        margin: 60px 0;
        a {
            line-height: 30px;
            display: inline-block;
        }
    }
}
</style>
